<template lang="pug">
v-layout(column wrap)
  .px-2.mb-2.py-2.error-info(v-if="hasError")
    span {{error}}
  v-flex.csv-uploader-container
    v-progress-linear.ma-0(v-if="loading" v-model="requestProgress")
    file-dropzone.dropzone.py-0(
      data-cy="file-dropzone"
      hide-file-limit
      hide-subtitle
      :maxSizeInMB="fileSizeLimit"
      :allowedFileExtensions="allowedFileExtensions"
      :file="file"
      :class="uploaderClasses"
      @readFile="handleFileRead"
      @loadRawFile="handleFileLoad"
      @removeFile="handleFileRemoved"
    )
      template(slot="title")
        span Drag and drop or click here to browse your computer to upload a CSV file (up to 200MB).
    v-progress-linear.ma-0(v-if="loading" v-model="requestProgress")
  v-flex.mt-3
    v-btn.ml-0(color="primary" @click="uploadFile" :loading="loading" :disabled="disabledBtn")
      | UPLOAD FILE
      template(slot="loader")
        v-progress-circular.pa-2(
          color="primary"
          size="20"
          indeterminate
        )
        span.pl-2 Uploading
    v-btn(v-if="showNextBtn" flat @click="handleNextStep") Next

</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import FileDropzone from '@/Core/components/FileDropzone';
import {
  CONTACTS_IMPORT_MAX_SIZE_MB,
  CONTACT_IMPORT_TYPE,
  MAX_SAMPLE_DATA_SIZE,
} from '../../../config/import-file';
import ALLOWED_FILE_EXTENSIONS from '../config/allowed-file-extensions';

const {
  mapActions: mapImportFileActions,
  mapState: mapImportFileState,
  mapMutations: mapImportFileMutations,
} = createNamespacedHelpers('importFile');

export default {
  components: {
    FileDropzone,
  },
  mounted() {
    if (this.uploadedFile) {
      this.file = this.uploadedFile;
    }
  },
  data() {
    return {
      fileSizeLimit: CONTACTS_IMPORT_MAX_SIZE_MB,
      allowedFileExtensions: ALLOWED_FILE_EXTENSIONS,
      sampleSize: MAX_SAMPLE_DATA_SIZE,
      type: CONTACT_IMPORT_TYPE,
      file: null,
      fileURL: '',
      isUploadAction: false,
    };
  },
  methods: {
    ...mapImportFileMutations(['clearMessages']),
    ...mapImportFileActions(['uploadImportFile', 'deleteImportFile']),
    handleFileLoad(file) {
      this.clearMessages();
      this.fileURL = '';
      this.file = file;
    },
    handleFileRead(fileURL) {
      this.fileURL = fileURL.target.result;
    },
    async handleFileRemoved() {
      if (this.file && this.importFileData && this.uploadedFile) {
        await this.deleteImportFile(this.importFileData.file_id);
      }
      this.clear();
    },
    clear() {
      this.clearMessages();
      this.file = null;
      this.fileURL = '';
    },
    async uploadFile() {
      this.isUploadAction = true;
      const data = {
        file: this.file,
        type: this.type,
        sampleSize: this.sampleSize,
      };

      await this.uploadImportFile(data);

      if (this.hasError) {
        return;
      }

      this.$emit('uploaded');
    },
    handleNextStep() {
      this.$emit('click:next');
    },
  },
  computed: {
    ...mapImportFileState(['loading', 'hasError', 'error', 'requestProgress', 'uploadedFile']),
    ...mapImportFileState({ importFileData: 'data' }),
    disabledBtn() {
      return !this.file || this.hasError || this.loading || this.uploadedFile;
    },
    uploaderClasses() {
      if (!this.loading) {
        return {};
      }

      return {
        disabled: true,
      };
    },
    showNextBtn() {
      return !this.isUploadAction && this.importFileData && this.uploadedFile;
    },
  },
};
</script>

<style lang="scss" scoped>
.dropzone {
  height: 350px;
}

.disabled {
  pointer-events: none;
  opacity: 0.4;
}

.csv-uploader-container {
  padding: 5px;
}

.error-info {
  border-color: var(--v-error-base);
  color: var(--v-error-base);
  border: 2px solid var(--v-error-base);
  border-radius: 10px;
}
</style>